import React from 'react';
import { StyleSheet, ScrollView, Pressable } from 'react-native';
import SlideModal from '@/Atoms/SlideModal';
import Box from '@/Atoms/Box';
import CCText from '@/Atoms/CCText';
import CCColors from '@/Utils/CCColors';
import { FontSizes } from '@/Utils/Dimensions';
import { MaterialCommunityIcons } from '@expo/vector-icons';

interface WebinarOption {
  batch_code: string;
  level: string;
  tournament_id: number;
  webinar_ids: number[];
  class_days: string[];
  unique_timings: string[];
}

interface WebinarDetailsModalProps {
  visible: boolean;
  onClose: () => void;
  planPerks?: string[];
  webinarOptions?: WebinarOption[];
  levelName?: string;
}

const WebinarDetailsModal: React.FC<WebinarDetailsModalProps> = ({
  visible,
  onClose,
  planPerks = [],
  webinarOptions = [],
  levelName,
}) => {
  return (
    <SlideModal
      visible={visible}
      showHeader
      showCloseIcon
      onClose={onClose}
      type="side"
      modalHeaderTitle={
        <Box type="row-center" gap={3}>
          <MaterialCommunityIcons name="web" size={18} color={CCColors.TextColor.Dark} />
          <CCText fontSize={FontSizes[16]} fontWeight="semibold">
            Masterclass Details
          </CCText>
        </Box>
      }>
      <ScrollView style={styles.scrollView} showsVerticalScrollIndicator={true}>
        <Box padding={20}>
          {/* Level Name */}
          {levelName && (
            <Box marginBottom={20}>
              <CCText
                fontSize={FontSizes[18]}
                fontWeight="bold"
                color={CCColors.TextColor.Dark}>
                {levelName} Masterclass
              </CCText>
            </Box>
          )}

          {/* Webinar Batches - Timing Details */}
          {webinarOptions.length > 0 ? (
            <Box>
              <CCText
                fontSize={FontSizes[16]}
                fontWeight="semibold"
                color={CCColors.TextColor.Dark}
                marginBottom={16}>
                Available Batches & Timings
              </CCText>
              {webinarOptions.map((option, index) => (
                <Box
                  key={`${option.batch_code}-${index}`}
                  style={{padding: 16, borderRadius: 12, borderWidth: 1, marginBottom: index < webinarOptions.length - 1 ? 16 : 0}}
                  backgroundColor={CCColors.White}
                  borderColor={CCColors.Grey.Divider200}>
                  <Box flexDirection="row" alignItems="center" marginBottom={12}>
                    <MaterialCommunityIcons
                      name="account-group"
                      size={18}
                      color={CCColors.Primary.Default}
                    />
                    <CCText
                      fontSize={FontSizes[15]}
                      fontWeight="semibold"
                      color={CCColors.TextColor.Dark}
                      style={{marginLeft: 8}}>
                      {option.batch_code}
                    </CCText>
                  </Box>

                  <Box flexDirection="row" alignItems="center" marginBottom={8}>
                    <MaterialCommunityIcons name="calendar" size={16} color={CCColors.TextColor.Grey} />
                    <CCText fontSize={FontSizes[13]} color={CCColors.TextColor.Dark} style={{marginLeft: 8}}>
                      {option.class_days.join(', ')}
                    </CCText>
                  </Box>

                  <Box flexDirection="row" alignItems="center">
                    <MaterialCommunityIcons name="clock-outline" size={16} color={CCColors.TextColor.Grey} />
                    <CCText fontSize={FontSizes[13]} color={CCColors.TextColor.Dark} style={{marginLeft: 8}}>
                      {option.unique_timings.join(', ')}
                    </CCText>
                  </Box>
                </Box>
              ))}
            </Box>
          ) : (
            <Box alignItems="center" style={{paddingVertical: 40}}>
              <MaterialCommunityIcons name="information-outline" size={48} color={CCColors.TextColor.Grey} />
              <CCText
                fontSize={FontSizes[14]}
                color={CCColors.TextColor.Grey}
                textAlign="center"
                style={{marginTop: 12}}>
                No timing details available at this time.
              </CCText>
            </Box>
          )}
        </Box>
      </ScrollView>
    </SlideModal>
  );
};

const styles = StyleSheet.create({
  scrollView: {
    flex: 1,
  },
});

export default WebinarDetailsModal;

